import { configureStore } from "@reduxjs/toolkit";
import chatReduer from "./chat";
import userReducer from "store/user";
import botReducer from "store/bot";
import createBotReducer from "store/createBot";
import editorReducer from "store/editor";
import shareReducer from "store/share";
import modalsReducer from "store/react-lib/generic-ui/modals";
import popupReducer from "store/react-lib/generic-ui/popup";
import codeEditorReducer from "store/codeEditor";
import conversationsReducer from "store/conversations";
import collectionsReducer from "store/react-lib/generic-ui/collections";
import documentsReducer from "store/documents";
import talkReducer from "store/talk";
import audioPlayerReducer from "store/audioPlayer";
import audioSliceReducer from "store/audioSlice";
import imageStudioReducer from "store/imageStudio";
import firestoreReducer from "store/firestore";
import imageEditorReducer from "store/imageEditor";

const store = configureStore({
  reducer: {
    chat: chatReduer,
    user: userReducer,
    bot: botReducer,
    createBot: createBotReducer,
    editor: editorReducer,
    share: shareReducer,
    modals: modalsReducer,
    popup: popupReducer,
    codeEditor: codeEditorReducer,
    conversations: conversationsReducer,
    collections: collectionsReducer,
    documents: documentsReducer,
    talk: talkReducer,
    audioPlayer: audioPlayerReducer,
    audio: audioSliceReducer,
    imageStudio: imageStudioReducer,
    firestore: firestoreReducer,
    imageEditor: imageEditorReducer,
  }
});

export default store;